var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Watch } from "vue-property-decorator";
import MasterDataService from "@/common/services/masterdataService";
import NavMenu from "@/template/components/NavMenu.vue";
import InfoBanner from "@/common/components/InfoBanner.vue";
import Notifications from "vue-notification";
import { Notification } from "@/common/services/notificationService";
import LanguageService from "@/common/services/LanguageService";
import BannerService from "@/common/services/BannerService";
import FooterNav from "@/common/components/FooterNav.vue";
import CookieConsentDialog from '@/template/components/CookieConsentDialog.vue';
import TermsOfUseDialog from '@/template/components/TermsOfUseDialog.vue';
import TermsOfUseService from "@/common/services/TermsOfUseService";
import AuthenticationService from '@/common/services/authenticationService';
import ExtendSessionDialog from '@/template/components/ExtendSessionDialog.vue';
Vue.use(Notifications);
var BounceLoader = require("vue-spinner/dist/vue-spinner.min").BounceLoader;
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.masterdataService = new MasterDataService();
        _this.bannerService = new BannerService();
        _this.termsOfUseService = new TermsOfUseService();
        _this.banner = null;
        _this.alreadyApproved = false;
        _this.disableShowExtended = false;
        _this.showExtendSession = false;
        _this.sessionExpirationWarningBeforeMin = 5;
        _this.sessionSupervisionIntervalSec = 60;
        return _this;
    }
    App.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, config;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.languageService.initLanguage();
                        _a = this;
                        return [4 /*yield*/, this.bannerService.getBanner()];
                    case 1:
                        _a.banner = _b.sent();
                        config = this.$store.state.vuexPageModule.configuration;
                        if (config.sessionExpirationWarningBeforeMin)
                            this.sessionExpirationWarningBeforeMin = config.sessionExpirationWarningBeforeMin;
                        if (config.sessionSupervisionIntervalSec && config.sessionSupervisionIntervalSec > 60) {
                            this.sessionSupervisionIntervalSec = config.sessionSupervisionIntervalSec;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    App.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promiseArray, spTime;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.disableShowExtended = false;
                        this.showExtendSession = false;
                        promiseArray = [];
                        promiseArray.push(this.initializeCurrentUser());
                        return [4 /*yield*/, Promise.all(promiseArray)];
                    case 1:
                        _a.sent();
                        document.onkeydown = function (evt) {
                            var isEscape = false;
                            if ("key" in evt) {
                                isEscape = (evt.key === "Escape" || evt.key === "Esc");
                            }
                            if (isEscape) {
                                var tooltips = document.getElementsByClassName("tooltip");
                                Array.from(tooltips).forEach(function (tooltip) { tooltip.setAttribute("aria-hidden", "true"); });
                            }
                        };
                        this.cookiePolicy.setPageView(this.$route.path);
                        spTime = 1000 * (this.sessionSupervisionIntervalSec && this.sessionSupervisionIntervalSec > 30 ? this.sessionSupervisionIntervalSec : 60);
                        window.setInterval(function () {
                            _this.checkIsLogInExpired(true);
                        }, spTime);
                        return [2 /*return*/];
                }
            });
        });
    };
    App.prototype.onChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.bannerService.getBanner()];
                    case 1:
                        _a.banner = _b.sent();
                        // Cookie policy is enforced on every navigation because the policy may change outside the 
                        // current app (Privacy policy page is its own app when opened in a new tab and it cannot
                        // disable the google analytics of the current tab).
                        // If this becomes an issue, consider approaches such as the BroadcastChannel API to 
                        // communicate between apps.
                        this.cookiePolicy.setPageView(this.$route.path);
                        this.checkIsLogInExpired(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    App.prototype.isRouterLoginExpiredCheckedFromServer = function (path) {
        return path && path.endsWith('changeRequests'); // changeRequest is the only page that does not load from server api
    };
    Object.defineProperty(App.prototype, "languageService", {
        get: function () {
            return new LanguageService(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "showBanner", {
        get: function () {
            var routeName = this.$router.currentRoute.name;
            return routeName !== "instructions" && routeName !== "accessibility-statement" && routeName !== "privacy-policy";
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.initializeCurrentUser = function () {
        return __awaiter(this, void 0, Promise, function () {
            var user, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.masterdataService.getCurrentUser()];
                    case 1:
                        user = _a.sent();
                        if (user) {
                            this.$store.commit("vuexPageModule/SET_CURRENTUSER", user);
                        }
                        else {
                            this.$store.commit("vuexPageModule/SET_CURRENTUSER", null);
                            error = this.$t("MasterData.UserFetchFailed");
                            Notification.error(this, error);
                        }
                        return [2 /*return*/, user];
                }
            });
        });
    };
    Object.defineProperty(App.prototype, "showLoader", {
        get: function () {
            return this.downloadingPdf
                || this.downloadingFile
                || (!this.isInSection && this.loading)
                || this.updating
                || (this.isInSection && this.isSectionLoading);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "isSectionLoading", {
        get: function () {
            return !this.$store.getters["vuexPageModule/sectionRenderReady"];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "downloadingFile", {
        get: function () {
            return this.$store.state.vuexPageModule.downloadingFile;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "downloadingPdf", {
        get: function () {
            return this.$store.state.vuexPageModule.downloadingPdf;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "loading", {
        get: function () {
            return this.$store.state.vuexPageModule.loading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "updating", {
        get: function () {
            return this.$store.state.vuexPageModule.updating;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "isInSection", {
        get: function () {
            return this.$store.state.vuexPageModule.section > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "size", {
        get: function () {
            return "100px";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "color", {
        get: function () {
            return "#fd5608";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "isInPrintMode", {
        get: function () {
            var hideNav = this.$route.meta.hideNav;
            return hideNav != null && hideNav === true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "currentUser", {
        get: function () {
            return this.$store.state.vuexPageModule.currentUser;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "isConsented", {
        get: function () {
            var ret = this.$store.state.vuexPageModule.isConsented;
            return ret;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "cookiePolicy", {
        get: function () {
            return this.$store.state.vuexPageModule.cookiePolicy;
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.onTermsAccepted = function (termsAccepted) {
        return __awaiter(this, void 0, Promise, function () {
            var responseOk, error, authService;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!termsAccepted) return [3 /*break*/, 2];
                        this.alreadyApproved = true;
                        return [4 /*yield*/, this.termsOfUseService.setTermsOfUseApprovedByUser()];
                    case 1:
                        responseOk = _a.sent();
                        if (!responseOk) {
                            this.alreadyApproved = false;
                            Notification.error(this, this.$t("TermsOfUse.TermsOfUseSetFailed"));
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error = this.$t("TermsOfUse.TermsNotAcceptedLogOutMessage");
                        Notification.error(this, error);
                        authService = new AuthenticationService;
                        return [4 /*yield*/, authService.logout()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    App.prototype.onExtendSession = function (extendSession) {
        return __awaiter(this, void 0, Promise, function () {
            var authService, result, error, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authService = new AuthenticationService;
                        if (!extendSession) return [3 /*break*/, 6];
                        this.showExtendSession = false;
                        console.debug('Ask Server to give more time for the Session');
                        return [4 /*yield*/, authService.extendLogin(this.currentUser.userName)];
                    case 1:
                        result = _a.sent();
                        if (!result) return [3 /*break*/, 2];
                        console.debug('Server gave permission to extend Session');
                        return [3 /*break*/, 5];
                    case 2:
                        console.debug('Server did not give permission to extend Session');
                        error = this.$t("ExtendLogin.ContinueLoginDeniedByServer");
                        Notification.error(this, error);
                        this.disableShowExtended = true;
                        return [4 /*yield*/, this.delay(1000)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, authService.logout()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 9];
                    case 6:
                        this.disableShowExtended = true;
                        error = this.$t("ExtendLogin.LogOutByUserMessage");
                        Notification.error(this, error);
                        return [4 /*yield*/, this.delay(1000)];
                    case 7:
                        _a.sent();
                        return [4 /*yield*/, authService.logout()];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9: return [2 /*return*/, null];
                }
            });
        });
    };
    App.prototype.onAlreadyApprovedByUser = function (alreadyApproved) {
        this.alreadyApproved = alreadyApproved;
    };
    App.prototype.checkIsLogInExpired = function (fromTimer) {
        // Login is expiring is defined by cookie
        var sessionExpiredPath = "/sessionExpired";
        var authService = new AuthenticationService();
        var isExpiredByCookie = authService.checkSessionExpiration();
        if (isExpiredByCookie) {
            if (!window.location.href.endsWith(sessionExpiredPath)) {
                window.location.href = sessionExpiredPath;
            }
            this.showExtendSession = false;
            this.disableShowExtended = true;
            return true;
        }
        if (fromTimer) {
            var loginExpiring = authService.checkSessionExpiringSoon(this.sessionExpirationWarningBeforeMin);
            if (!this.disableShowExtended) {
                this.showExtendSession = loginExpiring; // show opens ExtendSessionDialog
            }
            return false;
        }
        if (this.isRouterLoginExpiredCheckedFromServer(this.$route.path)) {
            if (!authService.isAuthenticated()) {
                if (!window.location.href.endsWith(sessionExpiredPath)) {
                    window.location.href = sessionExpiredPath;
                }
                this.showExtendSession = false;
                this.disableShowExtended = true;
                return true;
            }
        }
        return false;
    };
    App.prototype.delay = function (ms) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
            });
        });
    };
    __decorate([
        Watch("$route.path"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], App.prototype, "onChange", null);
    App = __decorate([
        Component({
            name: "Organisation"
        }),
        Component({
            name: "App",
            components: {
                NavMenu: NavMenu,
                InfoBanner: InfoBanner,
                BounceLoader: BounceLoader,
                FooterNav: FooterNav,
                CookieConsentDialog: CookieConsentDialog,
                TermsOfUseDialog: TermsOfUseDialog,
                ExtendSessionDialog: ExtendSessionDialog
            }
        })
    ], App);
    return App;
}(Vue));
export default App;
